import { createContext, useContext } from 'react';
import { IDisclosureContext } from '@vivli/features/disclosures/infrastructure/interface';

export const DisclosureContext = createContext<IDisclosureContext>(null);

export const useDisclosureContext = () => useContext(DisclosureContext);
